export default __webpack_public_path__ + "static/media/buffalo_product.24be60bf.svg";